
import AthleteReservations from "@/pages/athlete/AthleteReservations";

const AthleteHistory = () => {
  return <AthleteReservations initialTab="history" />;
};

export default AthleteHistory;
